import { FontSize } from '@config/theme/sizes'
import { Stack, styled, Typography } from '@mui/material'

type ErrorPageProps = {
	code: string
	explanation: string
	message: string
}

/**
 * Error page
 * @param code
 * @param explanation
 * @param message
 * @constructor
 */
const ErrorPage = (
	{
		code,
		explanation,
		message
	}: ErrorPageProps
) => {
	return (
		<Container>
			<Typography fontSize={FontSize.XXXXXL}>
				{code}
			</Typography>
			<Typography fontSize={FontSize.XXL}>
				{message}
			</Typography>
			<Typography>
				{explanation}
			</Typography>
		</Container>
	)
}

const Container = styled(Stack)({
	alignItems: 'center',
	flex: 1,
	justifyContent: 'center',
	rowGap: '24px'
})

export default ErrorPage
